angular.module('jv.MyAccount.PersonalTemplates.Controller', [
    'jv.Common.Modal',
    'ngStorage'
])
.controller('personalTemplatesController', [
    '$scope', '$rootScope', 'myAccount', '$location', '$q', '$localStorage',
    function($scope, $rootScope, myAccount, $location, $q, $localStorage) {
        var confirmDeferred;
        var listMax = 10;
        $scope.state = {
            modals: {},
            currentPage: 0,
            listMax: 10,
            templates: []
        };
        $rootScope.breadcrumbsConfig.links.unshift({
            linkText: i18n['EMAIL_TEMPLATES'],
            link: $scope.jvUrls.admin+'/myaccount/profile.html#/emailTemplates'
        });
        // set current page from localstorage
        if ($localStorage.currentTemplatePage) {
            if ($localStorage.currentTemplatePageCount < 1) {
                $scope.state.currentPage = Math.max($localStorage.currentTemplatePage - 1, 0);
            }
            else {
                $scope.state.currentPage = $localStorage.currentTemplatePage;
            }
        }
        getTemplates($scope.state.currentPage);

        function getTemplates(page) {
            return myAccount.getEmailTemplates(page).then(function(res) {
                $scope.state.total = res.data.count;
                $scope.state.totalPages = Math.ceil(res.data.count / listMax);
                $scope.state.templates = res.data.userEmailTemplates;
                $scope.state.hasPrevious = ($scope.state.currentPage > 0);
                $scope.state.hasNext = ($scope.state.currentPage < $scope.state.totalPages - 1);
                $scope.state.currentStart = ($scope.state.listMax * $scope.state.currentPage + 1);
                $scope.state.currentEnd = ($scope.state.currentStart - 1 + $scope.state.templates.length);
                $scope.flags.loading = false;
                $localStorage.currentTemplatePage = page;
                $localStorage.currentTemplatePageCount = $scope.state.templates.length;
            }, function() {
                $scope.showMsg('UNABLE_TO_PERFORM', false, 'error');
            });
        }

        function confirmDelete() {
            confirmDeferred = $q.defer();
            $scope.state.modals.confirmDelete = true;
            return confirmDeferred.promise;
        }

        $scope.cloneTemplate = function(template) {
            $location.path('/emailTemplates/new');
            $location.search({
                name: template.name,
                subject: template.subject,
                body: template.body
            });
        };

        $scope.deleteTemplate = function(template) {
            confirmDelete().then(function() {
                $scope.flags.loading = true;
                return myAccount.deleteEmailTemplate(template).then(function() {
                    if ($scope.state.templates.length < 2 && $scope.state.totalPages > 1) {
                        $scope.state.currentPage -= 1;
                    }
                    return getTemplates($scope.state.currentPage);
                }).then(null, function() {
                    $scope.showMsg('UNABLE_TO_PERFORM', false, 'error');
                    return $q.reject();
                });
            }).finally(function() {
                $scope.state.modals.confirmDelete = false;
                $scope.flags.loading = false;
            });
        };

        $scope.deleteConfirm = function() {
            confirmDeferred.resolve();
        };

        $scope.deleteCancel = function() {
            confirmDeferred.reject();
        };

        $scope.addTemplate = function() {
            $location.path('/emailTemplates/new');
        };

        $scope.previousPage = function() {
            $scope.state.currentPage -= 1;
            $scope.flags.loading = true;
            getTemplates($scope.state.currentPage).finally(function() {
                $scope.flags.loading = false;
            });
        };

        $scope.nextPage = function() {
            $scope.state.currentPage += 1;
            $scope.flags.loading = true;
            getTemplates($scope.state.currentPage).finally(function() {
                $scope.flags.loading = false;
            });
        };
    }
]);